import axios from '@axios'
import ApiRouteProvider from '../route'
import {objectToGETParams} from '../route'

function getBasePath() {
    return ApiRouteProvider.getBaseUrl() + '/research/discovery/requests'
}

function getGatewayBaseUrl() {
    return ApiRouteProvider.getBaseUrl().replace(/\/api\/?$/, '')
}

export default {
    getRequests(filters = {}, page = 1, perPage = 20) {
        const query = objectToGETParams({
            ...filters,
            page,
            perPage,
        })

        return axios.get(getBasePath() + (query ? '?' + query : ''))
    },

    getRequest(id) {
        return axios.get(getBasePath() + '/' + id)
    },

    submitArtifactFeedback(requestId, fileReferenceId, payload) {
        return axios.post(
            getBasePath()
            + '/'
            + encodeURIComponent(requestId)
            + '/artifacts/'
            + encodeURIComponent(fileReferenceId)
            + '/feedback',
            payload
        )
    },

    getFeedbackAttempt(requestId, attemptId) {
        return axios.get(
            getBasePath()
            + '/'
            + encodeURIComponent(requestId)
            + '/feedback-attempts/'
            + encodeURIComponent(attemptId)
        )
    },

    getArtifactDownloadUrl(artifact) {
        if (!artifact || !artifact.namespace || !artifact.type || !artifact.fileRefId) {
            return ''
        }

        return getGatewayBaseUrl()
            + '/fg/download/'
            + encodeURIComponent(artifact.namespace)
            + '/'
            + encodeURIComponent(artifact.type)
            + '/'
            + encodeURIComponent(artifact.fileRefId)
    },

    downloadArtifactFile(artifact) {
        const url = this.getArtifactDownloadUrl(artifact)
        if (!url) {
            return Promise.reject(new Error('Invalid artifact download params'))
        }

        return axios({
            url,
            method: 'GET',
            responseType: 'blob',
        })
    },

}
